
<!-- 
  Article inner content
-->

<template>
  <div>
    <div class="article-body">

      <p v-html="project.date"></p>
      <h1 v-html="project.title"></h1>
      <p v-html="project.description"></p>
      
      <hr />
    </div>

    <!-- <div class="article-share">

      <a class="twitter-share-button share-button"
          v-bind:href="'https://twitter.com/intent/tweet?original_referer=https%3A%2F%2Fdev.twitter.com%2Fweb%2Ftweet-button&ref_src=twsrc%5Etfw&text='+project.sharemessage + '&tw_p=tweetbutton&url=http://thechronophobe.me/article/'+project.dir + '&hashtags='+project.hashtags" 
          data-size="large">
        <img :src="'../static/img/icons/icon_twitter.png'" />
      </a>

      <div class="facebook-share-button share-button" 
        @click="shareFB">
        <img :src="'../static/img/icons/icon_facebook.png'" />
      </div>

      <a href="https://www.instagram.com/thechronophobe/" target="_blank">
        <div class="instagram-share-button share-button">
          <img :src="'../static/img/icons/icon_instagram.png'" />
        </div>
      </a>

      <router-link to="/">
        <div class="share-button back-share-button">
          <img :src="'../static/img/icons/icon_home.png'" />
        </div>
      </router-link>
   
    </div> -->
  </div>
</template>

<style>

  .article-body {
    margin: 0 auto;
    padding-bottom: 20px;
    -moz-box-sizing:border-box;
    box-sizing: border-box;
    color: #ADADAD;
  }
  .article-body p img {
    width: 100%;
    max-width: 500px;
    margin:25px 0;
  }
  .article-top-section {
    text-align: left;
  }
  .article-share {
    /*margin:50px 0 30px;*/
      margin: 0px 0 30px;
      padding: 20px 10px 16px;
      border-radius: 0px;
      display: inline-block;
      width: 100%
  }
  .article-back-button {
    right:10px;
    top:10px;
  }

  .share-button {
    width: 64px!important;
    height:64px!important;
    border-radius: 6px!important;
    display: inline-block;
    margin: 0 10px;
  /*  box-shadow: 1px 1px 2px rgba(0,0,0,0.2);*/
    cursor: pointer;
  }
  .share-button img {
    width:100%;
  }

  .share-button:hover, .share-button:active {
    opacity: 0.6;
  }

  .article-article {
    position: relative;
    width:500px;
    margin:0 auto;
    text-align: left;
    padding:25px 0;
    border-left: 2px solid #f1f1f1;
    padding-left: 10px;
    background-color: #ffffff;
  }

  h1 {
    font-size: 31px;
    margin: 30px 0 30px;
    letter-spacing: 1px;
    color: #ADADAD;
  }

  p {
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
  }
  br {
    margin: 25px;
  }
  hr {
    margin: 30px 0 40px;
  }
  .span-pink {
    color:#E6007E;
  }
  @media only screen and (max-width: 620px) {
    .article-body {
      width:100%;
      padding:0 30px 0px;

    }
    .article-share {
       padding: 20px 0px 16px;
             margin: 0px 0 10px;
    }
    .share-button {
      width: 50px!important;
      height: 50px!important;
      margin: 0 5px;
    }
  }

</style>

<script>
// import Vue from 'vue'

export default {
  props: ['project'],
  data () {
    return {
    }
  },
  methods: {
    shareFB: function () {
      // facebook
      window.FB.ui({
        method: 'share',
        display: 'popup',
        title: this.project.sharetitle,
        name: this.project.sharetitle,
        link: this.project.sharetitle,
        picture: this.project.shareimg,
        caption: this.project.shareurl,
        description: this.project.sharedescription,
        href: this.project.shareurl
      }, function (response) {
        console.log('FB callback')
      })
    }
  },
  mounted: function () {
  },
  created () {
  },
  computed: {
    // a computed getter
  }
}
</script>



// WEBPACK FOOTER //
// ArticleView.vue?752cd9ee